import isNil from 'lodash/isNil';

import { PlateNumber } from 'store/modules/integration/ipCameras/types';

/** Dolynk importAllowList / removeAllowList: plateNumber max 64 bytes. */
export const PLATE_NUMBER_MAX_LENGTH = 64;

export function normalisePlateNumber(plateNumber: PlateNumber): PlateNumber {
  return plateNumber.trim().toUpperCase();
}

export function normalisePlateNumberSearch(search?: string): string | undefined {
  if (isNil(search)) {
    return undefined;
  }
  const normalised = normalisePlateNumber(search);
  return normalised || undefined;
}
